import React from "react";
import { MessageCircle } from "lucide-react";
import { trackEvent } from "../utils/analytics";

const WHATSAPP_NUMBER = "918651035362";
const DEFAULT_TEXT =
  "Hi OJOVEST - I am interested in Premium Loans & Elite Credit Card Offers.";

export default function WhatsAppButton() {
  const openWhatsApp = () => {
    trackEvent("whatsapp_click", { source: "floating_button" });

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      DEFAULT_TEXT
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={openWhatsApp}
      className="fixed bottom-5 right-5 z-[9999] flex items-center gap-2 rounded-full bg-green-600 px-4 py-3 text-white shadow-lg hover:bg-green-700 transition"
      aria-label="WhatsApp"
      type="button"
    >
      <MessageCircle size={20} />
      WhatsApp
    </button>
  );
}
